const storageToState = () => {
  const state = {
    hospitalID: '',
    hospitalId: '',
    hospitalInfo: '',
    token: '',
    userId: '',
    phone: '',
    TIM: '',
    TIMUploadPlugin: '',
    TRTC: '',
    tsignaling: '',
    userList: [],
    roleList: [],
    im: '',
    imId: '',
    imSign: '',
    imGroupId: '',
    imUserInfo: '',
    openId: '',
    imChatBtn: '',
    wdzxImChatBtn: {
      funcList: [],
      bottomFuncList: []
    },
    xtImChatBtn: {
      funcList: [],
      bottomFuncList: []
    },
    detailBtnList: [],
    updateImList: true,
    globalLoadingAnima: true,
    callStatus: '',
    imMessage: {},
    revMessage: {},
    patient: '',
    patientId: '',
    patientName: '',
    keyValue: '',
    targetKeyValue: '',
    doctorTitle: '',
    hasUserInfo: false,
    avatarUrl: '',
    nickName: '',
    deliveryMsg: {},
    masterList: [],
    currentMaster: {},
    goShopState: false,
    trtcConfig: '',
    newAddress: false,
    isAllow: false,
    doctor: {},
    pharmacist: {},
    intoDiagnose: false,
    orgList: [],
    chatState: false,
    videoState: false,
    audioState: false,
    noHos: false,
    isBindImEvent: false,
    patientUserId: '',
    isDoctor: false,
    isPharmacist: false,
    hospitalList: [],
    currentVisit: '',
    currentRole: '',

    pharmacyTemp: {},
    pharmacyTempPrice: '',
    memberList: [],
    isAdSelected: false,

    // 药师说明书
    leafletStatus: false,
    leafletData: null,
    fGetDoctorList: [],
    isSendDialog: false,
    consultationData: {},
    isVideoDialog: true
  }
  const hospitalInfo = localStorage.getItem('hospitalInfo')
  if (hospitalInfo) {
    state.hospitalInfo = JSON.parse(hospitalInfo)
  }
  state.token = localStorage.getItem('TOKEN')
  state.userId = localStorage.getItem('USERID')
  state.phone = localStorage.getItem('PHONE')
  state.openId = localStorage.getItem('OPENID')
  const orgList = localStorage.getItem('ORGLIST')
  if (orgList) {
    state.orgList = JSON.parse(orgList)
  }
  state.isPharmacist = localStorage.getItem('IS_PHARMACIST')
  const roleList = localStorage.getItem('roleList')
  if (roleList) {
    state.roleList = JSON.parse(roleList)
  }
  //   commit('SET_CURRENT_ROLE', uni.getStorageSync('currentRole'))
  const doctor = localStorage.getItem('DOCTOR')
  if (doctor) {
    state.doctor = JSON.parse(doctor)
  }
  state.imId = localStorage.getItem('IMID')
  state.hospitalID = localStorage.getItem('hospitalID ')
  const keyValue = localStorage.getItem('keyValue')
  if (keyValue) {
    state.keyValue = JSON.parse(keyValue)
  }
  const userList = localStorage.getItem('userList')
  if (userList) {
    state.userList = JSON.parse(userList)
  }
  console.log(state, '更新local到vuex')
  return state
}

// 把缓存的数据添加到vuex中
export default {
  state: storageToState(),
  mutations: {
    SET_GLOBAL_LOADING_ANIMA(state, val) {
      state.globalLoadingAnima = val
    },
    SET_TARGET_KEY_VALUE(state, val) {
      state.targetKeyValue = val
    },
    SET_HOSPITALID(state, val) {
      state.hospitalID = val
      state.hospitalId = val
    },
    SET_UPDATE_IMLIST(state, val) {
      state.updateImList = val
    },
    SET_ENV(state, val) {
      state.baseEnv = val
    },
    SET_USER_LIST(state, val = []) {
      state.userList = val
    },
    SET_PHARMACY_TEMP(state, { key, data }) {
      const temp = JSON.parse(JSON.stringify(state.pharmacyTemp))
      temp[key] = data
      state.pharmacyTemp = temp // 重新拉去一个对象让页面更新
    },
    DEL_PHARMACY_TEMP(state, val = {}) {
      state.pharmacyTemp = val
    },

    SET_ISAD_SELECTED(state, val) {
      state.isAdSelected = val
    },
    SET_PATIENT_USERID(state, val) {
      state.patientUserId = val
    },
    SET_HOSPITAL(state, val) {
      state.hospitalInfo = val
    },
    SET_TOKEN(state, val) {
      state.token = val
      localStorage.setItem('TOKEN', val)
    },
    SET_USERID(state, val) {
      state.userId = val
    },
    SET_PHONE(state, val) {
      state.phone = val
    },

    SET_IM(state, val) {
      state.im = val
    },
    SET_IMID(state, val) {
      state.imId = val
    },
    SET_GROUP_ID(state, val) {
      state.imGroupId = val
    },
    SET_SIGN(state, val) {
      state.imSign = val
    },
    SET_KEY_VALUE(state, val) {
      state.keyValue = val
    },
    SET_OPENID(state, val) {
      state.openId = val
    },
    SET_DELIVERY_MSG(state, val) {
      state.deliveryMsg = val
    },

    SET_DOCTOR(state, val) {
      state.doctor = val
    },
    SET_PHAR(state, val) {
      state.pharmacist = val
    },
    SET_SEARCH_DIAGNOSE(state, val) {
      state.intoDiagnose = val
    },
    SET_ORG_LIST(state, val) {
      state.orgList = val
    },
    SET_BUSINESS_LIST(state, val) {
      state.businessList = val
    },

    SET_DETAIL_BTNS(state, list = []) {
      state.detailBtnList = list
    },
    SET_IM_CHAT_BTN(state, val) {
      state.imChatBtn = val
    },
    SET_IM_WDZXCHAT_BTN(state, val) {
      state.wdzxImChatBtn = val
    },
    SET_IM_XTCHAT_BTN(state, val) {
      state.xtImChatBtn = val
    },
    SET_IS_PHARMACIST(state, val) {
      state.isPharmacist = val
    },

    SET_HOSPITAL_LIST(state, val) {
      state.hospitalList = val
    },
    SET_MEMBER_LIST(state, val) {
      state.memberList = val
    },

    // 说明书状态
    SET_LEAFLET_STATUS(state, status) {
      state.leafletStatus = status
    },
    // 说明书数据
    SET_LEAFLET_DATA(state, data) {
      state.leafletData = data
    },
    // 登录用户角色数据
    SET_ROLE_LIST(state, data) {
      state.roleList = data
    },
    // 用户当前的角色
    SET_CURRENT_ROLE(state, data) {
      state.currentRole = data
    },
    // 当前护士信息
    SET_NURSE(state, data) {
      state.nurse = data
    },
    // 群发消息里的受者
    SET_RECIPIENTS_LIST(state, data) {
      state.recipientsList = data
    },
    // 设置视频弹窗开关
    SET_ISVIDEO_DIALOG(state, data) {
      state.isVideoDialog = data

      setTimeout(() => {
        const ele = document.querySelector('#all-component-box') || ''
        ele.style.display = !data ? 'none' : 'block'
      }, 0)
    },
    SET_ISSEND_DIALOG(state, data) {
      state.isSendDialog = data
    },
    // 视频弹窗信息
    SET_CONSULTATION(state, data) {
      state.consultationData = data
      localStorage.setItem('CONSULTATION', JSON.stringify(data))
    }
  },
  actions: {
    // dispatch 说明书状态
    setLeafletStatus({ commit }, status) {
      commit('SET_LEAFLET_STATUS', status)
    },
    // dispatch 说明书传参
    setLeafletData({ commit }, data) {
      commit('SET_LEAFLET_DATA', data)
    }
  },
  getters: {
    leafletStatus: state => state.leafletStatus,
    leafletData: state => state.leafletData
  }
}
